import BtnFilled from '../../components/BtnFilled';
import dayjs from 'dayjs';
import { cn } from '../../utils/cn';
import { useIntegrationsStore } from './state/use-integrations-store';
import { DEVICE_TYPE } from './constants';
import ActionButtons from './ActionButtons';

const ItemInfo = ({ text, className }) => {
  return text && <div className={cn('text-center text-sm px-4 py-2.5 bg-gray-100 w-fit rounded-full', className)}>{text}</div>;
};

const IntegrationCard = ({ data, isDeferred }) => {
  const openModal = useIntegrationsStore((s) => s.openModal);
  const deviceInfo = data?.device_payload;
  const userName = deviceInfo?.user_info?.fio || 'ФИО';
  const serial_number = deviceInfo?.serial_number || 'Отсутствует';
  const date = dayjs(data?.date);
  const isExpired = date.isBefore(dayjs(), 'day');
  const isToday = date.isSame(dayjs(), 'day');

  return (
    <div className={'bg-white p-5 rounded-3xl'}>
      <div className={'flex items-center gap-2.5 mb-5'}>
        {isDeferred && <ItemInfo text={'Требует уточнения'} className={'bg-red-100'} />}
        {isToday && !isDeferred && <ItemInfo text={'Выполнить сегодня'} className={'bg-orange-500 text-white'} />}
        <ItemInfo className={isExpired ? 'bg-red-300' : ''} text={`${isExpired ? 'Просрочено' : 'Исполнить'} ${date?.format('DD.MM.YYYY')}`} />
      </div>
      <p className={'pb-3 text-xl'}>{userName}</p>
      <p className="pb-1">{DEVICE_TYPE[deviceInfo?.subtype_id] || 'Тип счетчика не указан'}</p>
      <p className={'text-xs'}>Серийный номер: {serial_number}</p>
      <BtnFilled title={'Подробнее'} btnCb={() => openModal(data)} className={'bg-gray-100 text-black hover:bg-gray-300 mt-5 mb-3'} />
      <ActionButtons isDeferred={true} deviceId={data?.device_id} />
    </div>
  );
};
export default IntegrationCard;
